module.exports = __webpack_public_path__ + "img/20200512_162720.ae26ba27.jpg";